<div class="row">
  <div class="col-12" *ngIf="reportingObj[index]">
    <div class="d-flex align-items-center">
      <div>
        <div class="d-flex align-items-center">
          <sb-comp-medium *ngIf="isMedium" class="mr-3" [background]="true"
                          [hoverPreview]="true" [medium]="reportingObj[index]?.element"></sb-comp-medium>
          <ng-container *ngIf="!isMedium" [ngSwitch]="selectedField">
            <div class="pictureFrame mr-3">
              <!-- the same view can be shown in more than one case -->
              <sb-comp-medium *ngSwitchCase="'mediumGroup'" [background]="true"
                              [hoverPreview]="true"
                              [medium]="reportingObj[index]?.element.preview"></sb-comp-medium>
              <sb-comp-medium *ngSwitchCase="'medium'" [background]="true"
                              [hoverPreview]="true" [medium]="reportingObj[index]?.element"></sb-comp-medium>
              <div *ngSwitchCase="'product'" class="backgroundFrame"
                   [style.backgroundImage]="reportingObj[index]?.element?.depiction?.url ? 'url(' + reportingObj[index]?.element?.depiction?.url + ')' : ''">
              </div>
              <div *ngSwitchCase="'productCategory'" class="backgroundFrame"
                   [style.backgroundImage]="reportingObj[index]?.element?.illustration?.url ? 'url(' + reportingObj[index]?.element?.illustration?.url + ')' : ''">
              </div>
              <!--default case when there are no matches -->
            </div>
          </ng-container>
          <div>
            <p class="font-weight-bold m-0" [innerHTML]="reportingObj[index]?.element?.name | truncate : 50"></p>
            <p class="m-0" [innerHTML]="reportingObj[index]?.element?.description | truncate: 50"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3 h-100 p-3 text-end md-auto offset-md-4 ">{{'lang.globals.total' | translate}}</div>
      <sb-local-date-input class="col-5" (modelChange)="handleDateChange($event)" [enabledDates]="enabledDates()"
                           [minDate]="from" [maxDate]="till"></sb-local-date-input>

    </div>
    <div class="row">
      <div class="col-4 h-100 p-3 text-end md-auto ">{{'lang.globals.playouts' | translate}}</div>
      <div class="d-flex justify-content-end col-3 text-end align-items-center" id="playouts">{{fillPlayouts()}}</div>
      <div class="d-flex justify-content-end col text-end align-items-center"
           id="playoutsDate">{{fillPlayoutsForDate()}}</div>
    </div>
    <div class="row ">
      <div class="col-4 h-100 p-3 text-end md-auto">{{'lang.globals.playoutsTime' | translate}}</div>
      <div class="d-flex justify-content-end col-3 text-end align-items-center"
           id="playouttime">{{fillPlayoutTime()}}</div>
      <div class="d-flex justify-content-end col text-end align-items-center"
           id="playouttimeDate">{{fillPlayoutTimeForDate()}}</div>
    </div>
    <div class="row">
      <div class="col-4 h-100 p-3 text-end md-auto">{{'lang.globals.timeslotmostplayouts' | translate}}</div>
      <div class="d-flex justify-content-end col-3 text-end align-items-center"
           id="timeslot">{{fillMostPlayed()}}</div>
      <div class="d-flex justify-content-end col text-end align-items-center"
           id="timeslotDate">{{fillMostPlayedForDate()}}</div>
    </div>
  </div>
</div>
